export default {
    getOrganisationTenantId(org) {
        if (org.ownerId) {
            return org.ownerId
        }
        return org.id
    }
}